import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import { useKonamiCode } from "./hooks/useKonamiCode";
import SiteChrome from "./components/SiteChrome";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { ContentProvider } from "./context/ContentContext";
import { EditModeProvider } from "./context/EditModeContext";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminLayout from "./components/admin/AdminLayout";

// Pages publiques
import Home from "./pages/Home";
import Ateliers from "./pages/Ateliers";
import Cursus from "./pages/Cursus";
import Stages from "./pages/Stages";
import Boutique from "./pages/Boutique";
import Elearning from "./pages/Elearning";
import Entreprises from "./pages/Entreprises";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Reserver from "./pages/Reserver";
import ReserverSuccess from "./pages/ReserverSuccess";
import ReserverCancel from "./pages/ReserverCancel";

// Pages admin
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOffers from "./pages/admin/AdminOffers";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminPromos from "./pages/admin/AdminPromos";
import AdminSlots from "./pages/admin/AdminSlots";
import AdminCenters from "./pages/admin/AdminCenters";
import AdminStages from "./pages/admin/AdminStages";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminEmails from "./pages/admin/AdminEmails";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminBlog from "./pages/admin/AdminBlog";
import Politique from "./pages/Politique";
import MentionsLegales from "./pages/MentionsLegales";
import Cgv from "./pages/Cgv";

function AppContent() {
  useKonamiCode();

  return (
    <>
      <ScrollToTop />
      <Toaster />
          <Routes>
            {/* Routes admin (sans banner/popup publics) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="offers" element={<AdminOffers />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="promos" element={<AdminPromos />} />
              <Route path="slots" element={<AdminSlots />} />
              <Route path="centers" element={<AdminCenters />} />
              <Route path="stages" element={<AdminStages />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="emails" element={<AdminEmails />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="avis" element={<AdminTestimonials />} />
              <Route path="blog" element={<AdminBlog />} />
            </Route>

            {/* Routes publiques */}
            <Route
              path="/*"
              element={
                <SiteChrome>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/ateliers" element={<Ateliers />} />
                    <Route path="/cursus" element={<Cursus />} />
                    <Route path="/stages" element={<Stages />} />
                    <Route path="/boutique" element={<Boutique />} />
                    <Route path="/elearning" element={<Elearning />} />
                    <Route path="/entreprises" element={<Entreprises />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:postId" element={<BlogPost />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/rgpd" element={<Politique />} />
                    <Route path="/politique-confidentialite" element={<Politique />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/cgv" element={<Cgv />} />
                    <Route path="/reserver" element={<Reserver />} />
                    <Route path="/reserver/success" element={<ReserverSuccess />} />
                    <Route path="/reserver/cancel" element={<ReserverCancel />} />
                  </Routes>
                </SiteChrome>
              }
            />
          </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <ContentProvider>
            <EditModeProvider>
              <BrowserRouter>
                <AppContent />
              </BrowserRouter>
            </EditModeProvider>
          </ContentProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
